import { useEffect, useState } from "react";
import { Modal, Select } from "antd";

import { PostCase, postCaseDisplayName } from "../../../api/postCaseAPI";

export const CASE_UNASSIGN_VALUE = "__unassign__";

interface Props {
  open: boolean;
  cases: PostCase[];
  selectedCount: number;
  itemLabel: string;
  onCancel: () => void;
  onSubmit: (value: number | typeof CASE_UNASSIGN_VALUE) => void;
}

const CaseAssignModal = ({
  open,
  cases,
  selectedCount,
  itemLabel,
  onCancel,
  onSubmit,
}: Props) => {
  const [value, setValue] = useState<number | string>(CASE_UNASSIGN_VALUE);

  useEffect(() => {
    if (open) setValue(cases.length > 0 ? cases[0].postCaseId : CASE_UNASSIGN_VALUE);
  }, [open, cases]);

  return (
    <Modal
      open={open}
      title="Case 배정"
      okText="적용"
      cancelText="취소"
      onOk={() => onSubmit(value === CASE_UNASSIGN_VALUE ? CASE_UNASSIGN_VALUE : Number(value))}
      onCancel={onCancel}
      centered
      destroyOnClose
      width={420}
    >
      <div style={{ marginBottom: 12, fontSize: 13, color: "#595959", lineHeight: 1.6 }}>
        선택한 {itemLabel} <b>{selectedCount}</b>개의 Case 를 아래 값으로 바꿉니다.
        {" "}실제 반영은 아래 <b>확인</b>을 눌렀을 때 이뤄집니다.
      </div>
      <Select
        style={{ width: "100%" }}
        value={value}
        onChange={(v) => setValue(v)}
        options={[
          ...cases.map((pc, i) => ({
            label: pc.organ
              ? `${postCaseDisplayName(pc, i)} — ${pc.organ}`
              : postCaseDisplayName(pc, i),
            value: pc.postCaseId,
          })),
          { label: "미배정", value: CASE_UNASSIGN_VALUE },
        ]}
      />
    </Modal>
  );
};

export default CaseAssignModal;
